import { useEffect, useState } from 'react';
import ReactTagSelect from 'components/reactTagSelect';
import { transformDataCustomSelect } from 'utils/common';
import LabMasterService from 'services/admin/masters/LabService';

const labServiceObject = new LabMasterService();

export default function TagTab(props) {
    const { labDetails, bindGeneralInfo } = props;
    const { labtags } = labDetails;
    const [selectedValues, setSelectedValues] = useState([]);
    const [tagsList, setTagList] = useState([]);
    useEffect(() => {
        labServiceObject.getAllTagsList().then(response => {
            setTagList(transformDataCustomSelect(response))
        }).catch(err => {
            console.log('error in tags data')
        })
    }, [])

    useEffect(() => {
        let values = [];
        labtags && labtags.length > 0 && labtags.map(el => {
            tagsList.filter(list => {
                if (list.label === el) {
                    values.push(list);
                }
                return null;
            })
            return null;
        })
        setSelectedValues(values);
        // eslint-disable-next-line
    }, [labDetails])

    const createIdForDynamicTag = async (newValue, dynamicTag) => {
        const payload = {
            name: dynamicTag.label,
            tag_type_id: 1,
        }
        let result = await labServiceObject.createIdForDynamicTag(payload)
        if (result) {
            newValue.forEach(element => {
                element.value = (element.value === result.name) ? result.id : element.value;
            });
        }
        getSelectedIdsForTag(newValue);
    }

    const getSelectedIdsForTag = (newValue) => {
        let selectedIds = [];
        newValue.forEach(element => {
            selectedIds.push(element.value);
        });
        bindGeneralInfo('tags', selectedIds);
        setSelectedValues(newValue);
    }

    const handleChange = (newValue, actionMeta) => {
        if (actionMeta && actionMeta.option && actionMeta.option.__isNew__) {
            createIdForDynamicTag(newValue, actionMeta.option)
        }
        else {
            getSelectedIdsForTag(newValue)
        }

    }

    return (
        <ReactTagSelect
            options={tagsList}
            placeholder='Search / Create tags here'
            onChange={handleChange}
            selectedValues={selectedValues}
        />
    )
}